import { useQuery } from '@tanstack/react-query'

import { type EmployeeWithPaySchedules } from 'components/payroll/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'

type useGetEmployeesParams = {
  pagination: {
    pageIndex: number
    pageSize: number
  }
  search: string
}

export function getEmployeesQueryKey ({ pagination, search }: useGetEmployeesParams) {
  return ['employers', 'employees', 'pagination', pagination, 'search', search]
}

export function useGetEmployees ({
  pagination,
  search
}: useGetEmployeesParams) {
  return useQuery<PaginatedResponse<EmployeeWithPaySchedules>, GrapeAPIErrorType>({
    queryKey: getEmployeesQueryKey({ pagination, search }),
    queryFn: async () => {
      const queryParams: Record<string, any> = {
        'page[number]': pagination.pageIndex.toString(),
        'page[size]': pagination.pageSize.toString(),
        search: search ?? '',
      }
      const queryString = new URLSearchParams(queryParams).toString()
      const response = await fetchWithHeaders(`/api/web/employers/employees?${queryString}`)

      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors
        })
      }

      return response.json()
    },
  })
}
